<template>
  <div class="user-grid">
    <table class="table">
      <thead>
        <tr>
          <th class="text-left" scope="col">Email</th>
          <th class="text-center" scope="col">Student Role</th>
          <th class="text-center" scope="col">Mentor Role</th>
          <th class="text-center" scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in users" :key="index">
          <td class="text-left align-middle">
            <span class="user-name"
              >{{ user.firstName }} {{ user.lastName }}</span
            ><span class="user-email">{{ user.email }}</span>
          </td>
          <td class="text-center align-middle">
            <toggle-button
              :on="user.roles.includes(roleMap.Student)"
              @click="
                user.roles.includes(roleMap.Student)
                  ? confirmRemove(user, index, roleMap.Student, $event)
                  : confirmAdd(user, index, roleMap.Student, $event)
              "
            ></toggle-button>
          </td>
          <td class="text-center align-middle">
            <toggle-button
              :on="user.roles.includes(roleMap.Mentor)"
              @click="
                user.roles.includes(roleMap.Mentor)
                  ? confirmRemove(user, index, roleMap.Mentor)
                  : confirmAdd(user, index, roleMap.Mentor)
              "
            ></toggle-button>
          </td>
          <td class="text-center align-middle">
            <b-button
              variant="primary"
              size="sm"
              class="action-button red"
              @click="$emit(events.messageUser, user.id)"
            >
              <b-icon-envelope-fill class="action-icon"></b-icon-envelope-fill>
              send message
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              class="action-button red"
              @click="$emit(events.viewProfile, user)"
            >
              <b-icon-person-fill class="action-icon"></b-icon-person-fill>
              view profile
            </b-button>
            <a
              :href="editUserUrl + user.id"
              target="_blank"
              class="btn btn-primary btn-sm action-button red"
              ><b-icon-person-lines-fill
                class="action-icon"
              ></b-icon-person-lines-fill
              >edit user</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <confirmation-modal
      :title="modalData.title"
      :question="modalData.question"
      :yesActionText="modalData.yesActionText"
      :noActionText="modalData.noActionText"
      :yesCallback="modalData.yesCallback"
      :noCallback="modalData.noCallback"
      ref="confirmation-modal"
    ></confirmation-modal>
  </div>
</template>

<script>
import ToggleButton from "../forms/ToggleButton.vue";
import ConfirmationModal from "../forms/ConfirmationModal.vue";
import {
  BIconEnvelopeFill,
  BButton,
  BIconPersonFill,
  BIconPersonLinesFill
} from "bootstrap-vue";
import { RoleModalMessages } from "../lib/MessageBuilder";
import { RoleMap } from "../lib/Constants";

export const RemoveRoleEvent = "remove-role";
export const AddRoleEvent = "add-role";
export const ManageUserEvent = "manage-user";
export const MessageUserEvent = "message-user";
export const ViewProfileEvent = "view-profile";

export const Events = {
  manageUser: ManageUserEvent,
  messageUser: MessageUserEvent,
  viewProfile: ViewProfileEvent,
  addRole: AddRoleEvent,
  removeRole: RemoveRoleEvent
};

export default {
  name: "UserGrid",
  data: function() {
    return {
      events: Events,
      roleMap: RoleMap,
      modalData: {
        title: "",
        question: "",
        yesActionText: "",
        noActionText: "",
        yesCallback: function() {},
        noCallback: function() {}
      }
    };
  },
  components: {
    ConfirmationModal,
    ToggleButton,
    BIconEnvelopeFill,
    BIconPersonFill,
    BButton,
    BIconPersonLinesFill
  },
  props: {
    users: { type: Array, default: () => [] },
    editUserUrl: { type: String, required: true }
  },
  methods: {
    alert: msg => alert(msg),
    confirmRemove: function(user, index, roleName) {
      const that = this;
      this.modalData = {
        title: RoleModalMessages.RemoveTitle(),
        question: RoleModalMessages.RemoveRole(user, roleName),
        yesActionText: RoleModalMessages.RemoveRoleYesAction(roleName),
        noActionText: RoleModalMessages.CommonCancelAction(),
        yesCallback: () =>
          that.$emit(RemoveRoleEvent, {
            id: user.id,
            email: user.email,
            role: roleName
          }),
        noCallback: () => that.$refs["confirmation-modal"].resetProperties()
      };
      this.$refs["confirmation-modal"].showModal();
    },
    confirmAdd: function(user, index, roleName) {
      const that = this;
      this.modalData = {
        title: RoleModalMessages.AddTitle(),
        question: RoleModalMessages.AddRole(user, roleName),
        yesActionText: RoleModalMessages.AddRoleYesAction(roleName),
        noActionText: RoleModalMessages.CommonCancelAction(),
        yesCallback: () =>
          that.$emit(AddRoleEvent, {
            id: user.id,
            email: user.email,
            role: roleName
          }),
        noCallback: () => that.$refs["confirmation-modal"].resetProperties()
      };
      this.$refs["confirmation-modal"].showModal();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.action-icon {
  font-size: 1.5rem;
  margin-right: 0.25rem;
}
.action-button {
  margin: 0.25rem;
}

.user-name {
  font-weight: 600;
}
.user-email {
  font-size: 80%;
  display: block;
}
</style>
